import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild, ViewEncapsulation,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from "../../../../crystal-elements/cc-base.component";
import {FormFieldGroupConfig} from "../../../../model/api/form-field-group-config";
import {FormFieldConfig} from "../../../../model/api/form-field-config";
import {ReportTotalResidual} from "../../../../model/archive/report-total-residual";
import {ReportTotalResidualService} from "../../../../services/archive/report-total-reisdual.service";
import {JsonProperty} from "@hyperloris/tyson";
import {ClearingUtils} from "../../../../utils/clearing-utils";
import {CcFormComponent} from "../../../../crystal-elements/form-dialog/form/cc-form.component";
import {DateTime} from "luxon";
import {DatePipe, DecimalPipe} from "@angular/common";
import TYPE = FormFieldConfig.TYPE;
import Origin = ReportTotalResidual.Origin;

@Component({
  selector: 'app-report-total-residual-form',
  templateUrl: './report-total-residual-form.component.html',
  styleUrls: ['./report-total-residual-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
    DatePipe,
    DecimalPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportTotalResidualFormComponent extends CcBaseComponent {

  transPartKey: string = 'total-residual';

  formLoading: boolean = false;

  formSubmitted: boolean = true;

  formConfig: FormFieldGroupConfig[] = [];

  dialogFormTitle: string = '';

  formRecord: any = {totalResiduals: [], selectedDate: ClearingUtils.getYesterdayBusinessDate()};

  showDesk: boolean = false;

  totalResiduals: ReportTotalResidual[] = [];

  @ViewChild('ccForm')
  ccForm: CcFormComponent;

  hasAdjustments: boolean = false;
  hasModification: boolean = false;

  constructor(cdref: ChangeDetectorRef,
              protected reportTotalResidualService: ReportTotalResidualService,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService,
              private decimalPipe: DecimalPipe,
              private datePipe: DatePipe) {
    super(cdref, messageService, translateService);
  }

  protected initConfigs() {
    super.initConfigs();
    this.refreshConfig();
    this.dialogFormTitle = this.getTranslation('page.' + this.transPartKey + '.title');
    this.loadData();
  }


  public loadData() {
    this.formLoading = true;
    this.reportTotalResidualService.isDailyReportEnabled().subscribe(apiValidation => {
      if (apiValidation.success) {
        this.formRecord['dailyReportEnabled'] = apiValidation.item;
        this.loadTotalResiduals();
      } else {
        this.errorMessage(apiValidation.message);
        this.formLoading = false;
      }
    })
  }

  sendReport(toAll: boolean) {
    this.formLoading = true;
    this.reportTotalResidualService.sendReport(toAll).subscribe(validation => {
      if (!validation.success) {
        this.errorMessage(validation.message);
      }
      else{
        this.infoMessage(this.getTranslation('page.' + this.transPartKey +'.sendMessage'));
      }
      this.formLoading = false;
      this.markForCheck();
    });
  }

  enableResidualReport(enable: boolean) {
    this.formLoading = true;
    this.reportTotalResidualService.enableDailyReport(enable).subscribe(validation => {
      if (!validation.success) {
        this.errorMessage(validation.message);
      }
      this.formLoading = false;
      this.markForCheck();
    });
  }

  protected loadTotalResiduals() {
    if (this.formRecord.selectedDate) {
      this.formLoading = true;

      const selectDateSt = this.datePipe.transform(this.formRecord.selectedDate, 'yyyy-MM-dd');
      this.reportTotalResidualService.list(selectDateSt).subscribe(apiValidation => {
          if (apiValidation.success) {
            this.totalResiduals = apiValidation.item;
            this.refreshTotalResidualTable(false);
          } else {
            this.totalResiduals = [];
            this.errorMessage(apiValidation.message);
          }
          this.formLoading = false;
        }
      );
    }
  }

  private refreshTotalResidualTable(reset: boolean) {
    this.formLoading = true;
    this.refreshTotalResidualRows(reset);
    if (this.formRecord.counterParty) {
      this.filterCounterParty();
    } else {
      this.refreshTotalRow();
    }
    this.refreshFieldData();
    this.formLoading = false;
  }

  private refreshTotalResidualRows(reset: boolean = false) {
    const selectedDate: Date = this.formRecord.selectedDate;
    this.formRecord.totalResiduals = [];
    this.formRecord.hiddenTotalResiduals = [];
    this.showDesk = false;
    // const totResidualRowTotal = this.getTotalResidualRowTotal();
    this.totalResiduals.forEach(totRes => {
        let totResidualRow: ReportTotalResidualRow = this.formRecord.totalResiduals.find(totResRow => totResRow.counterParty === totRes.counterParty
          && totResRow.deskId === totRes.deskId);
        if (!totResidualRow) {
          totResidualRow = {
            counterParty: totRes.counterParty,
            deskId: totRes.deskId,
            tradeDatePAL: 0,
            tradeDatePALOrigin: 0,
            tradeDatePALOriginWithoutForced: 0,
            prevDayTotal: 0,
            overallTotal: 0,
            isAdjusted: false,
            isFullTotalRow: false
          };
          this.formRecord.totalResiduals.push(totResidualRow);
        }
        if (DateTime.fromISO(totRes.businessDate + "").toISODate() === DateTime.fromISO(selectedDate.toISOString()).toISODate()) {
          if (!reset || totRes.origin != Origin.FORCE) {
            totResidualRow.tradeDatePAL += totRes.totalResidual;
            totResidualRow.overallTotal += totRes.totalResidual;
          } else {
            totResidualRow.tradeDatePAL += 0;
          }
          totResidualRow.tradeDatePALOrigin += totRes.totalResidual;
          if (totRes.origin != Origin.FORCE) {
            totResidualRow.tradeDatePALOriginWithoutForced += totRes.totalResidual;
          }
          // totResidualRowTotal.tradeDatePAL += totRes.totalResidual;
          // totResidualRowTotal.overallTotal += totRes.totalResidual;
          if (!reset && !totResidualRow.isAdjusted && totRes.origin == Origin.FORCE) totResidualRow.isAdjusted = true;
        } else {
          // if (!reset || totRes.origin != Origin.FORCE) {
          totResidualRow.prevDayTotal += totRes.totalResidual;
          totResidualRow.overallTotal += totRes.totalResidual;
          // }
          // totResidualRowTotal.prevDayTotal += totRes.totalResidual;
          // totResidualRowTotal.overallTotal += totRes.totalResidual;
        }
        if (totRes.deskId && totRes.deskId != totRes.counterParty
          && totRes.deskId.length > 0) this.showDesk = true;
      }
    );
    this.formRecord.totalResiduals.sort((a, b) => {
      if (a.deskId && b.deskId)
        return a.counterParty - b.counterParty + a.deskId - b.deskId;
      return a.counterParty - b.counterParty;
    });
    // const totResidualRowTotal = this.getTotalResidualRowTotal();
    // this.formRecord.totalResiduals.push(totResidualRowTotal);
  }

  private getTotalResidualRowTotal() {
    const totResidualRowTotal: ReportTotalResidualRow = {
      counterParty: this.getTranslation('page.' + this.transPartKey + '.form.total'),
      deskId: undefined,
      tradeDatePAL: 0,
      tradeDatePALOrigin: 0,
      tradeDatePALOriginWithoutForced: 0,
      prevDayTotal: 0,
      overallTotal: 0,
      isAdjusted: false,
      isFullTotalRow: true
    }
    return totResidualRowTotal;
  }

  private filterCounterParty() {
    const allTotalResiduals = [...this.formRecord.totalResiduals];
    allTotalResiduals.splice(this.formRecord.totalResiduals.length - 1)
    if (this.formRecord.hiddenTotalResiduals) {
      allTotalResiduals.push(...this.formRecord.hiddenTotalResiduals);
    }
    const newTotalResiduals = [];
    const hiddenTotalResiduals = [];
    // allTotalResiduals.sort((a, b) => {
    //   if (a.deskId && b.deskId)
    //     return a.counterParty - b.counterParty + a.deskId - b.deskId;
    //   return a.counterParty - b.counterParty;
    // });
    this.formRecord.totalResiduals = [];
    this.formRecord.hiddenTotalResiduals = [];
    // const totResidualRowTotal = this.getTotalResidualRowTotal();
    allTotalResiduals.forEach(totalResidual => {
      if (!this.formRecord.counterParty || !totalResidual.counterParty || totalResidual.counterParty.toUpperCase()
        .includes(this.formRecord.counterParty.toUpperCase())) {
        newTotalResiduals.push(totalResidual);
      } else {
        hiddenTotalResiduals.push(totalResidual);
      }
    });
    // console.log("-----> totalResidual "+JSON.stringify(newTotalResiduals))
    // console.log("-----> this.formRecord.counterParty "+this.formRecord.counterParty.toUpperCase())
    // console.log("-----> totalResidual.counterParty.toUpperCase "+totalResidual.counterParty.toUpperCase())
    this.formRecord.totalResiduals.push(...newTotalResiduals);
    this.formRecord.hiddenTotalResiduals.push(...hiddenTotalResiduals);
    this.refreshTotalRow();
    // this.refreshTotalRow(allTotalResiduals);
  }

  private refreshTotalRow() {
    let totResidualRowAll = this.formRecord.totalResiduals[this.formRecord.totalResiduals.length - 1];
    if (!totResidualRowAll || !totResidualRowAll.isFullTotalRow) {
      totResidualRowAll = this.getTotalResidualRowTotal();
      this.formRecord.totalResiduals.push(totResidualRowAll);
    }
    // const totResidualRowAll = this.formRecord.totalResiduals[this.formRecord.totalResiduals.length - 1];
    totResidualRowAll.tradeDatePAL = 0;
    totResidualRowAll.prevDayTotal = 0;
    totResidualRowAll.overallTotal = 0;
    this.formRecord.totalResiduals.forEach(totResidualRow => {
      if (!totResidualRow.isFullTotalRow) {
        totResidualRowAll.tradeDatePAL += totResidualRow.tradeDatePAL;
        totResidualRowAll.prevDayTotal += totResidualRow.prevDayTotal;
        totResidualRowAll.overallTotal += totResidualRow.overallTotal;
      }
    });
  }

  protected refreshConfig() {

    this.formConfig = [
      {
        group: '',
        fields: [
          {
            column: 4,
            field: 'generateReport',
            type: TYPE.BUTTONS,
            buttons: [{
              icon: 'fas fa-user',
              class: 'p-button-info',
              label: this.getTranslation('page.' + this.transPartKey + '.form.generateForUser'),
              command: event => {
                this.sendReport(false);
              }
            }, {
              icon: 'fas fa-users',
              class: 'p-button-help',
              label: this.getTranslation('page.' + this.transPartKey + '.form.generateForAll'),
              command: event => {
                this.sendReport(true);
              }
            }]
          },
          {
            field: 'dailyReportEnabled',
            column: 2,
            type: TYPE.CHECKBOX,
            useOffLabel: true,
            class: 'header-filter',
            changed: event => {
              this.enableResidualReport(event.checked);
            }
          },
          {
            column: 1,
            type: TYPE.NONE,
          },
          {
            field: 'selectedDate',
            required: true,
            column: 2,
            type: TYPE.DATE,
            class: 'header-filter',
            changed: event => {
              const [day, month, year] = this.formRecord.selectedDate.split('/');
              // this.formRecord.selectedDate = new Date(+year, +month - 1, +day);
              this.formRecord.selectedDate = new Date(Date.UTC(+year, +month - 1, +day, 0, 0, 0));
              this.loadTotalResiduals();
            }
          },
          {
            field: 'counterParty',
            required: false,
            column: 2,
            class: 'header-filter',
            type: TYPE.TEXT,
            // changed: event => {
            //   setTimeout(() => this.refreshTotalResidualTable(false), 500);
            // },
            // input: (event: any, event2: any, inputField: HTMLInputElement) => {
            changed: event => {
              this.formLoading = true;
              // var start = inputField.selectionStart;
              // var end = inputField.selectionEnd;
              // // queueMicrotask(() => {
              // this.refreshTotalResidualRows();
              // this.refreshTotalRow();
              this.filterCounterParty();
              // this.refreshFieldData();
              // this.cdref.detectChanges();
              this.ccForm.reloadFieldValueMap();
              this.hasAdjustments = this.hasAdjustments_();
              this.hasModification = this.hasModification_();
              // this.refreshConfig();
              // inputField.setSelectionRange(start, end);
              this.formLoading = false;
              // });
            },
            fieldIconRight: 'fas fa-magnifying-glass',
            // rightButton: {
            //   icon: 'fas fa-xmark',
            //   command: event => {
            //     this.formRecord.counterParty = undefined;
            //     this.loadTotalResiduals();
            //   }
            // }
          },
          {
            column: 1,
            type: TYPE.NONE,
            class: 'header-filter',
            rightButton: {
              icon: 'fas fa-xmark',
              class: 'p-button-warning clear-filter',
              command: (event, formRecord) => {
                this.formRecord.counterParty = undefined;
                this.filterCounterParty();
                this.ccForm.reloadFieldValueMap();
                this.hasAdjustments = this.hasAdjustments_();
                this.hasModification = this.hasModification_();
              }
            },
            disabled: record => !this.formRecord.counterParty
          },
          {
            field: 'totalResiduals',
            required: true,
            filter: true,
            column: 12,
            type: TYPE.TABLEFORMFIELD,
            // validate: record => this.validateSplits(record),
            richFieldConfig: {
              // canDelete: formRecords => this.canDeleteSplit(formRecords),
              // canAdd: formRecords => this.canAddSplit(formRecords),
              // addNew: formRecords => this.addSplit(formRecords),
              style: formRecord => (formRecord.isFullTotalRow ? 'bottom: 0; position: sticky; background: #212529;' : '') +
                (formRecord.isAdjusted ? 'background: ' + (formRecord.tradeDatePAL == formRecord.tradeDatePALOrigin ? '#1b4448fa;' : '#483B1BFA;') : ''),
              fields: [
                {
                  group: '',
                  fields: [
                    {
                      field: 'counterParty',
                      column: 1,
                      type: TYPE.NONE,
                      icon: id => '',
                      iconValue: (event, formRecord) => formRecord.counterParty,
                      style: record => record.isFullTotalRow ? 'color: var(--orange) !important' : ''
                    },
                    {
                      field: 'deskId',
                      column: 1,
                      type: TYPE.NONE,
                      icon: id => '',
                      iconValue: (event, formRecord) => formRecord.deskId,
                      hidden: record => !this.showDesk,
                      style: record => record.isFullTotalRow ? 'color: var(--orange) !important' : ''
                    },
                    {
                      field: 'tradeDatePAL',
                      column: 1,
                      type: TYPE.DECIMAL,
                      fractionDigits: record => 4,
                      changed: (event, record) => {
                        // this.cdref.detectChanges();
                        // this.ccForm.reloadFieldValueMap();
                        if (!record.tradeDatePAL) record.tradeDatePAL = 0;
                        if (!record.overallTotal) record.overallTotal = 0;
                        record.overallTotal = record.prevDayTotal + record.tradeDatePAL;
                        record.isAdjusted = record.tradeDatePAL != record.tradeDatePALOriginWithoutForced;
                        this.refreshTotalRow();
                        this.ccForm.reloadFieldValueMap();
                        this.hasAdjustments = this.hasAdjustments_();
                        this.hasModification = this.hasModification_();
                        // this.ccForm.reloadFieldValueMap();
                      },
                      disabled: record => record.isFullTotalRow,
                      style: record => record.isFullTotalRow ? 'color: var(--orange) !important' : ''
                    },
                    {
                      field: 'prevDayTotal',
                      column: 1,
                      type: TYPE.NONE,
                      icon: id => '',
                      iconValue: (event, formRecord) => this.decimalPipe.transform(formRecord.prevDayTotal, '1.0-4'),
                      style: record => record.isFullTotalRow ? 'color: var(--orange) !important' : ''
                    },
                    {
                      field: 'overallTotal',
                      column: 1,
                      type: TYPE.DECIMAL,
                      fractionDigits: record => 4,
                      changed: (event, record) => {
                        if (!record.overallTotal) record.overallTotal = 0;
                        if (!record.overallTotal) record.tradeDatePAL = 0;
                        record.tradeDatePAL = record.overallTotal - record.prevDayTotal;
                        record.isAdjusted = record.tradeDatePAL != record.tradeDatePALOriginWithoutForced;
                        this.refreshTotalRow();
                        this.ccForm.reloadFieldValueMap();
                        this.hasAdjustments = this.hasAdjustments_();
                        this.hasModification = this.hasModification_();
                      },
                      disabled: record => record.isFullTotalRow,
                      style: record => record.isFullTotalRow ? 'color: var(--orange) !important' : ''
                    },
                    {
                      field: 'isAdjusted',
                      column: 1,
                      type: TYPE.NONE,
                      icon: (id, formRecord) => formRecord.isFullTotalRow ? '' :
                        ((formRecord.isAdjusted ? (!formRecord.tradeDatePALOrigin ? 'fa-solid fa-circle' : 'fa-solid fa-circle-check') : '')),
                      iconValue: (event, formRecord) => '',
                      style: record => 'text-align: center;',
                    }]
                },
              ]
            }
          },
        ]
      }
    ];
  }

  refreshFieldData(): void {
    this.refreshConfig();
    this.cdref.detectChanges();
    this.formLoading = false
    this.hasAdjustments = this.hasAdjustments_();
    this.hasModification = this.hasModification_();
  }

  hasAdjustments_(): boolean {
    let hasAdjustments = false;

    this.formRecord.totalResiduals.forEach(totalResRow => {
      if (totalResRow.isAdjusted)
        hasAdjustments = true;
    })

    return hasAdjustments;
  }

  hasModification_(): boolean {
    let hasModification = false;

    this.formRecord.totalResiduals.forEach(totalResRow => {
      if (!totalResRow.isFullTotalRow && totalResRow.tradeDatePAL != totalResRow.tradeDatePALOrigin)
        hasModification = true;
    })

    return hasModification;
  }

  cancel() {
    this.loadTotalResiduals();
    // this.refreshTotalResidualTable(false);
  }

  reset() {
    this.formRecord.counterParty = undefined;
    this.refreshTotalResidualTable(true);
  }

  save() {
    this.formLoading = true;

    const forceTotalResiduals: ReportTotalResidual[] = [];
    const allTotalResiduals = [...this.formRecord.totalResiduals];
    if (this.formRecord.hiddenTotalResiduals)
      allTotalResiduals.push(...this.formRecord.hiddenTotalResiduals);
    allTotalResiduals.filter(value => !value.isFullTotalRow).forEach(totResRow => {

      // const totalResidual = this.totalResiduals.find(totRes => totRes.businessDate == this.formRecord.selectedDate
      //   && totRes.counterParty === totResRow.counterParty
      //   && totRes.deskId === totResRow.deskId);
      // if (!totalResidual) {
      if (totResRow.isAdjusted) {
        forceTotalResiduals.push({
          counterParty: totResRow.counterParty,
          deskId: totResRow.deskId,
          origin: Origin.FORCE,
          businessDate: this.formRecord.selectedDate,
          totalResidual: totResRow.tradeDatePAL
        });
      }
      // } else if (totalResidual.totalResidual != totResRow.tradeDatePAL) {
      //   if (totResRow.tradeDatePAL - totalResidual.totalResidual != 0) {
      //     forceTotalResiduals.push({
      //       counterParty: totResRow.counterParty,
      //       deskId: totResRow.deskId,
      //       origin: Origin.FORCE,
      //       businessDate: this.formRecord.selectedDate,
      //       totalResidual: totResRow.tradeDatePAL - totalResidual.totalResidual
      //     });
      //     console.log("------>2 totResRow " + JSON.stringify(totResRow))
      //   }
      // }
    });

    const selectDateSt = this.datePipe.transform(this.formRecord.selectedDate, 'yyyy-MM-dd');
    this.reportTotalResidualService.adjust(selectDateSt, forceTotalResiduals).subscribe(validation => {
      if (validation.success) {
        this.successMessage(this.getTranslation('page.' + this.transPartKey + '.adjustment_applied'));
        this.loadTotalResiduals();
      } else {
        this.errorMessage(validation.message);
      }
      this.formLoading = false;
    });
  }

  dailyReportEnabledChanged() {

  }
}

export class ReportTotalResidualRow {
  @JsonProperty()
  counterParty: string;
  @JsonProperty()
  deskId: string;
  @JsonProperty()
  tradeDatePAL: number;
  @JsonProperty()
  tradeDatePALOrigin: number;
  @JsonProperty()
  tradeDatePALOriginWithoutForced: number;
  @JsonProperty()
  prevDayTotal: number;
  @JsonProperty()
  overallTotal: number;
  @JsonProperty()
  isAdjusted: boolean = false;
  @JsonProperty()
  isFullTotalRow: boolean = false;
}
